import ContributionsListText from "components/authors/ContributionsListText";
import {
  LetterbookLibraryType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import ResponsiveCoverLink from "components/Cover/ResponsiveCoverLink";
import LetterbookCell from "../LetterbookCell";

export default function OwnerDetailsColumn({
  letterbook,
}: {
  letterbook: LetterbookLibraryType;
}) {
  const { book } = letterbook;
  const { ownerUserBook } = letterbook.data;

  return (
    <LetterbookCell>
      <div className="flex items-center space-x-2 min-w-max">
        <ResponsiveCoverLink
          book={book}
          edition={ownerUserBook?.edition}
          size="md"
          sizeLg="md"
          sizeSm="sm"
          className="shrink "
        />
        <div className="flex flex-col ">
          <div className="text-lg font-bold truncate max-w-xxs sm:max-w-sm md:max-w-md">
            {ownerUserBook?.edition?.title || book.title}
          </div>
          <div className="text-sm truncate max-w-xxs sm:max-w-sm md:max-w-md">
            <ContributionsListText contributions={book.contributions} />
          </div>
        </div>
      </div>
    </LetterbookCell>
  );
}

export const settings = {
  key: "OwnerDetails",
  title: "Details",
} as LetterlistTableColumnSettingType;
